module.exports = __webpack_public_path__ + "static/media/circle-model-icon.1d7c0227.svg";